import React, { useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import RouterSuspense from '~/app/common/RouterSuspense';
import Add from './Add';
import Detail from './Detail';
import TaskDetail from './Detail/Tasks/Detail';
import AddTask from './Detail/Tasks/Add';
import WorkOrder from './index';
import TaskServiceCheck from './Detail/Tasks/Detail/ServiceCheck';
import { useStoreState } from '~/store';
import { ROUTES } from '~/app/Router';

export const WORKORDER_ROUTES = {
    list: '/workorders',
    add: '/workorders/add/:machineId?',
    addTask: '/workorders/:id/add-task',
    taskServiceCheck: '/workorders/:id/:type/:taskId/service-check',
    taskDetail: '/workorders/:id/:type/:taskId',
    detail: '/workorders/:id',
};

export type RouterComponent = React.FC

const Router: RouterComponent = () => {
    const history = useHistory();
    const netWorkStatus = useStoreState(state => state.app.offline.status);

    useEffect(() => {
        if (netWorkStatus !== 0) {
            history.push(ROUTES.projects);
        }
    }, [netWorkStatus, history]);

    if (netWorkStatus !== 0) {
        return null;
    }

    return (
        <RouterSuspense>
            <Switch>
                <Route path={WORKORDER_ROUTES.add} component={Add} />
                <Route path={WORKORDER_ROUTES.addTask} component={AddTask} />
                <Route path={WORKORDER_ROUTES.taskServiceCheck} component={TaskServiceCheck} />
                <Route path={WORKORDER_ROUTES.taskDetail} component={TaskDetail} />
                <Route path={WORKORDER_ROUTES.detail} component={Detail} />
                <Route exact path={WORKORDER_ROUTES.list} component={WorkOrder} />
            </Switch>
        </RouterSuspense>
    );
};

export default Router;